import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { initI18nWithoutICU, I18nextProvider } from '@wix/wix-i18n-config';
import { App } from './App/App';
import { setBIOptions } from './utils/bi';
import { DEVICE } from './utils/helpers';
import { initWixRecorder } from './utils/initWixRecorder';
import { ContextProvider } from './context/ContextProvider';
import { initSentry } from './utils/initSentry';

const initialI18n = window.__INITIAL_I18N__;
const baseURL = window.__BASEURL__;
const initialState = window.__INITIAL_STATE__;
const consentPolicy = window.__CONSENT_POLICY__;
const device = window.__DEVICE__;
const biOptions = window.__BI__;
const experiments = window.__EXPERIMENTS__ || {};
// Adoric need to have this link in the window
window.templateEditUrl = window.__INITIAL_STATE__.template.editorUrl;

(() => {
  window?.consentPolicyManager?.init({ baseUrl: baseURL, consentPolicy });
  window?.wixTagManager?.init('TEMPLATES', initialI18n.locale);

  initWixRecorder(experiments);
  initSentry();
  setBIOptions(biOptions);

  const i18n = initI18nWithoutICU({ locale: initialI18n.locale, messages: initialI18n.resources });
  const app = (
    <ContextProvider initialState={initialState}>
      <I18nextProvider i18n={i18n}>
        <App mobile={device !== DEVICE.DESKTOP} />
      </I18nextProvider>
    </ContextProvider>
  );

  const container = document.getElementById('root');
  if (!container) {
    throw new Error('there is no #root element');
  }
  // hack for insider issues need to use directly render.
  // Only dev purposes specs.funnel.TemplateViewerOffReactDomHydrate
  if (experiments['specs.funnel.TemplateViewerOffReactDomHydrate'] === 'true') {
    createRoot(container).render(app);
  } else {
    hydrateRoot(container, app, {
      onRecoverableError: (error) => {
        console.error(error);
        // @ts-expect-error
        window?.Sentry?.captureException(error);
      },
    });
  }
})();
